import type { RewardCenterFaqQuery } from "@workspace/casino_core/queries/RewardCenterFaqQuery";
import { CMS_BRAND_SLUG } from "../../constants";
import type { FaqItem } from "../../types";

type Row = NonNullable<
  NonNullable<
    NonNullable<RewardCenterFaqQuery["cms"]>["Loyalties"]
  >["docs"][number]["faq"]
>[number];
type Phrase = Row["title"];

const phraseText = (phrase: Phrase): string | undefined =>
  phrase?.brandOverwrites?.find(
    (overwrite) => overwrite?.brand?.slug === CMS_BRAND_SLUG,
  )?.value ||
  phrase?.value ||
  undefined;

// `undefined` is a response we cannot read, and the backend retries it. A brand
// without FAQ entries is an empty list.
const mapFaq = (
  data: RewardCenterFaqQuery | undefined,
): FaqItem[] | undefined => {
  const docs = data?.cms?.Loyalties?.docs;
  if (!docs) return undefined;

  const items: FaqItem[] = [];
  for (const row of docs[0]?.faq ?? []) {
    const question = phraseText(row?.title);
    const answer = phraseText(row?.description);
    if (!row?.id || !question || !answer) continue;
    items.push({ id: row.id, question, answer });
  }
  return items;
};

export default mapFaq;
